import React from 'react';
import { teamMembers } from '../mock';
import { Card } from './ui/card';

const Team = () => {
  return (
    <section className="team-section" id="team">
      <div className="container">
        <h2 className="section-title-center">Meet the Team</h2>
        <p className="section-subtitle-center">
          The creative minds bringing The Nick and JJ Show to life!
        </p>
        
        <div className="team-grid">
          {teamMembers.map((member) => (
            <Card key={member.id} className="team-card">
              <div className="team-image-wrapper">
                <img 
                  src={member.image} 
                  alt={member.name}
                  className="team-image"
                />
              </div>
              <div className="team-content">
                <h3 className="team-name">{member.name}</h3>
                <a
                  href={member.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="team-role-link"
                >
                  {member.role}
                </a>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;